import React, { useEffect, useState } from 'react'

import styles from './LiveAnnouncer.module.scss'

export const LiveAnnouncer = ({ liveText }: LiveAnnouncerProps) => {
  const [text, setText] = useState<string>('')

  useEffect(() => {
    if (liveText) {
      setText(liveText)
    }

    setTimeout(() => {
      setText('')
    }, 100)
  }, [liveText])

  return (
    <div aria-live="polite" className={styles.offScreen}>
      <span>{text}</span>
    </div>
  )
}

interface LiveAnnouncerProps {
  liveText: string
}
